module.exports = __webpack_public_path__ + "img/Snipaste_2022-06-17_10-24-48.355ac4b8.png";